import { GeneralToggle } from "../../general";

// Values same as in `TagsSortKey` enum at the back.
const SortKey = {
  CONVERSIONS_AMOUNT: "conversions-amount",
  CREATION_DATE: "creation-date",
};

const sortKeys = [
  {
    title: "Convs. Amount",
    value: SortKey.CONVERSIONS_AMOUNT,
  },
  {
    title: "Creation Date",
    value: SortKey.CREATION_DATE,
  },
];

const TagsSortKeySelect = ({ sortKey, setSortKey }) => {
  return (
    <GeneralToggle
      label="Sort Key"
      value={sortKey}
      setValue={setSortKey}
      items={sortKeys}
      fixedMinWidth={true}
    />
  );
};

export { SortKey };

export default TagsSortKeySelect;
